import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center w-full h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "block text-gray-500" }, "Cette fonctionnalité est en cours de developpement", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'ComingSoon',
  props: {
		css: {
			type: String,
			default: "",
		},
	},
  setup(__props) {

	

return (_ctx: any,_cache: any) => {
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Image, {
      src: "/media/images/illustrations/work-in-progress-animate.svg",
      css: "block w-[250px] h-[250px]"
    }),
    _hoisted_2
  ]))
}
}

})